type StringToColorArgs = {
  color?: string;
  fallback?: string;
};

export const toHexColor = ({ color, fallback }: StringToColorArgs): string => {
  if (!Boolean(color) && !Boolean(fallback)) return null; // Default color if string is empty

  if (!Boolean(color) && Boolean(fallback)) {
    return toHexColor({
      color: fallback,
    });
  }

  return color.startsWith('#') ? color : `#${color}`;
};
